import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import './Styles.css';

const { Option } = Select;

class SelectTiposDeJornadasSATItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: false,
    };

    this.buscarTiposDeJornadas = debounce(this.buscarTiposDeJornadas.bind(this), 300);
  }

  componentDidMount() {
    // Cargar los primeros 10 al abrir por primera vez
    this.buscarTiposDeJornadas('');
  }

  componentDidUpdate(prevProps) {
    if(prevProps.value !== this.props.value) {
      // Si el valor cambia, reiniciar las opciones
      if(this.props.value){
        const buscarTipo = this.state.opciones.find(tipo => tipo._id.toString() === this.props.value.toString());
        if (!buscarTipo){
          this.buscarTiposDeJornadas(this.props.value || '');
        }
      }
    }
  }

  async buscarTiposDeJornadas(texto) {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "tiposDeJornadasSAT/selectTiposDeJornadasItem",
        {
          empresaId: this.props.empresaId,
          query: texto,
          values: this.props.value
        },
        {
          headers: this.props.headersToken,
        }
      );

      if (res.data.success === 2) {
        this.setState({
          opciones: res.data.tiposDeJornadas,
          primerCarga: true,
        });
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      console.error("Error al buscar tipos de jornadas:", error);
      this.setState({ opciones: [] });
    } finally {
      // Asegurar que siempre se quite el loading
      this.setState({ cargando: false });
    }
  }


  render() {
    const {
      noBuscar,
      mode,
      selectAll,
      mostrarCarga,
      onSelectAll,
      disabled,
      fondoBlanco,
      sinBorde,
      width,
      style,
      placeholder,
      ...restProps
    } = this.props;

    const propsNuevas = {
      showSearch: !noBuscar,
      filterOption: false,
      mode: mode,
      onSearch: this.buscarTiposDeJornadas,
      // Mostrar loading cuando está cargando, o mensaje cuando no hay resultados
      notFoundContent: this.state.cargando ? (
        <div style={{ textAlign: 'center', padding: '8px' }}>
          <div style={{ marginTop: '8px', fontSize: '12px', color: '#999' }}>
            Buscando tipos de jornadas...
          </div>
        </div>
      ) : this.state.primerCarga ? 'No se encontraron tipos de jornadas' : null,
      // Mostrar loading en el input del select
      loading: this.state.cargando,
    };

    if (mode === 'multiple') {
      propsNuevas.maxTagCount = 'responsive';
    }

    const estiloFinal = {
      color: disabled ? 'black' : 'inherit',
      backgroundColor: disabled ? (fondoBlanco ? 'white' : 'white') : null,
      borderBottom: sinBorde ? 'none' : '1px solid #E0FFFFFF',
      borderRadius: '4px',
      transition: 'border-color 0.3s ease',
      boxShadow: sinBorde ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
      width: width || undefined,
      opacity: disabled ? 1 : undefined,
      ...style,
    };


    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={400}
        disabled={disabled}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>
            {menu}
          </Spin>
        )}
        {...propsNuevas}
        {...restProps}
        onChange={(value) => {
          const tipo = this.state.opciones.find((tipo) => tipo._id === value);
          this.props.onChange(value, tipo)
        }}
        placeholder={this.state.cargando && !this.state.primerCarga ? "Cargando..." : placeholder}
        style={estiloFinal}
        bordered={false}
      >
        {this.state.opciones.map((tipo) => (
          <Option key={tipo._id} value={tipo._id}>
            {tipo.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectTiposDeJornadasSATItem;